// Liga window.onerror e unhandledrejection o mais cedo possível no boot (é o
// segundo import do main.js, logo depois do watchdog). Erros que acontecerem
// enquanto os outros módulos carregam ficam num buffer e são enviados quando o
// main.js chama `configurarMonitoramento`.
import { iniciarCapturaGlobal } from "@/service/monitoramentoErros";

iniciarCapturaGlobal({
  // No Jest o console é dos testes; não interceptar.
  interceptarConsole: process.env.NODE_ENV !== "test",
});
